import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  sales_orders: [],
};

const getters = {
  allSalesOrders: (state) => state.sales_orders,
};

const actions = {
  async fetchSalesOrders({ commit }, params = {}) {
    try {
      commit("resetSalesOrders");
      const response = await axios.get("/sales-order", {
        params: prm(params),
      });
      commit("setSalesOrders", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_orders:", error);
      if (error.status == 404) {
        commit("setSalesOrders", { data: [] });
        return { data: [] };
      }
    }
  },
  async createSalesOrder({ commit }, sales_order) {
    console.log("sales_order", sales_order);
    try {
      const response = await axios.post("/sales-order", sales_order);
      commit("addSalesOrder", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create sales_order:", error);
      throw error;
    }
  },
  async fetchSalesOrderById(_, id) {
    try {
      const response = await axios.get(`/sales-order/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_order:", error);
      throw error;
    }
  },
  async updateSalesOrder({ commit }, sales_order) {
    try {
      const response = await axios.put(
        `/sales-order/${sales_order.id}`,
        sales_order
      );
      commit("updateSalesOrder", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update sales_order:", error);
      throw error;
    }
  },
  async closeSalesOrder({ commit }, sales_order) {
    try {
      const response = await axios.post(`/sales-order/close`, sales_order);
      commit("closeSalesOrder", response.data);
    } catch (error) {
      console.error("Failed to close sales_order:", error);
      throw error;
    }
  },
  async deleteSalesOrderById({ commit }, id) {
    try {
      const response = await axios.delete(`/sales-order/${id}`);
      commit("removeSalesOrder", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete sales_order:", error);
      throw error;
    }
  },
  async importSalesOrder(_, sales_order) {
    console.log("sales_order", sales_order);
    try {
      const response = await axios.post("/sales-import", sales_order);
      return response.data;
    } catch (error) {
      console.error("Failed to import sales_order:", error);
      throw error;
    }
  },
};

const mutations = {
  setSalesOrders(state, sales_orders) {
    state.sales_orders = sales_orders.data; // Ensure this matches your API's response structure
  },
  addSalesOrder(state, sales_order) {
    state.sales_orders.push(sales_order);
  },
  updateSalesOrder(state, updatedSalesOrder) {
    const index = state.sales_orders.findIndex(
      (sales_order) => sales_order.id === updatedSalesOrder.id
    );
    if (index !== -1) {
      state.sales_orders.splice(index, 1, updatedSalesOrder);
    }
  },
  closeSalesOrder(state, closedSalesOrder) {
    const index = state.sales_orders.findIndex(
      (sales_order) => sales_order.id === closedSalesOrder.id
    );
    if (index !== -1) {
      state.sales_orders.splice(index, 1, closedSalesOrder);
    }
  },
  removeSalesOrder(state, id) {
    state.sales_orders = state.sales_orders.filter(
      (sales_order) => sales_order.id !== id
    );
  },
  resetSalesOrders(state) {
    state.sales_orders = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
